module.exports = __webpack_public_path__ + "img/logo-taff-42-2.3650432e.svg";